
import { useEffect, useRef } from "react";

export function useLockBodyScroll(open) {
    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);
}


export const handleNumberInput = (e, setter) => {
    const value = e.target.value;
    const integerPattern = /^\d*$/;
    if (integerPattern.test(value)) {
        setter(value);
    }
};

export const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
};

export const checkSameCustomer = (selectedOrders) =>
    selectedOrders.every(o => o.CustomerID === selectedOrders[0].CustomerID);











